export default "__VITE_ASSET__PaIVvDz7__"